import { render, staticRenderFns } from "./dangerousGoodIdentifier.vue?vue&type=template&id=050dfda7"
import script from "./dangerousGoodIdentifier.vue?vue&type=script&lang=js"
export * from "./dangerousGoodIdentifier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports